import(/* webpackMode: "eager", webpackExports: ["VideoPlayer"] */ "/home/runner/_work/core/core/apps/arclight/src/app/videoPlayerUrl/VideoPlayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/home/runner/_work/core/core/node_modules/@apollo/client-integration-nextjs/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
